import { createSlice } from "@reduxjs/toolkit";
import { getUserData } from "../services/user";

const userSlice = createSlice({
	name: "user",
	initialState: {
		userData: {
			firstName: "",
			lastName: "",
			email: "",
			userType: "",
			birthDate: "",
			personalIDType: "",
			personalID: "",
			genre: "",
			country: "",
			state: "",
			district: "",
			corregimiento: "",
			address: "",
			livingPlace: "",
			livingPlaceNumber: "",
			cellPhone: "",
			extraContactPhone: "",
			extraContactPhoneType: "",
			nationality: "",
			bloodType: "",
			ocupation: "",
			profession: "",
			ethnicity: "",
			citizenStatus: "",
			photo: "",
		},
		progress: {
			photo: 0,
			datosPersonales: 0,
			datosAdicionales: 0,
			datosEmergencias: 0,
			documents: 0,
			dhPersonal: 0,
			dhMedication: 0,
			dhDonation: 0,
			dhFamilyHistory: 0,
			dhHospitalization: 0,
			dhChronicDiseases: 0,
			isComplete: false,
		},
		isLoading: false,
		error: false,
		errorMessage: "",
	},
	reducers: {
		setLoading: (state, action) => {
			state.isLoading = action.payload;
		},
		setError: (state, action) => {
			state.error = action.payload;
		},
		setErrorMessage: (state, action) => {
			state.errorMessage = action.payload;
		},
		setUserData: (state, action) => {
			state.userData = {
				firstName: action.payload.firstName,
				lastName: action.payload.lastName,
				email: action.payload.email,
				userType: action.payload.userType,
				birthDate: action.payload.birthDate,
				personalIDType: action.payload.personalIDType,
				personalID: action.payload.personalID,
				genre: action.payload.genre,
				country: action.payload.country,
				state: action.payload.state,
				district: action.payload.district,
				corregimiento: action.payload.corregimiento,
				address: action.payload.address,
				livingPlace: action.payload.livingPlace,
				livingPlaceNumber: action.payload.livingPlaceNumber,
				cellPhone: action.payload.cellPhone,
				extraContactPhone: action.payload.extraContactPhone,
				extraContactPhoneType: action.payload.extraContactPhoneType,
				nationality: action.payload.nationality,
				bloodType: action.payload.bloodType,
				ocupation: action.payload.ocupation,
				profession: action.payload.profession,
				ethnicity: action.payload.ethnicity,
				citizenStatus: action.payload.citizenStatus,
				photo: action.payload.photo,
				datosPersonales: action.payload.datosPersonales,
				datosAdicionales: action.payload.datosAdicionales,
				ongID: action.payload.ongID,
			};
			state.progress = {
				photo: action.payload.progressionID.photo,
				datosPersonales: action.payload.progressionID.datosPersonales,
				datosAdicionales: action.payload.progressionID.datosAdicionales,
				datosEmergencias: action.payload.progressionID.datosEmergencias,
				documents: action.payload.progressionID.documents,
				dhPersonal: action.payload.progressionID.dhPersonal,
				dhMedication: action.payload.progressionID.dhMedication,
				dhDonation: action.payload.progressionID.dhDonation,
				dhFamilyHistory: action.payload.progressionID.dhFamilyHistory,
				dhHospitalization: action.payload.progressionID.dhHospitalization,
				dhChronicDiseases: action.payload.progressionID.dhChronicDiseases,
				isComplete: action.payload.progressionID.isComplete,
			};
		},
	},
});

export const { setLoading, setError, setErrorMessage, setUserData } =
	userSlice.actions;
export default userSlice.reducer;

// redux thunk
export const fetchUserData = (userID) => {
	return async (dispatch) => {
		dispatch(setLoading(true));
		dispatch(setError(false));
		dispatch(setErrorMessage(""));
		try {
			const response = await getUserData(userID);
			dispatch(setUserData(response));
		} catch (error) {
			dispatch(setError(true));
			dispatch(setErrorMessage(error.message));
		} finally {
			dispatch(setLoading(false));
		}
	};
};
